import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { first } from 'rxjs/operators'
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { CourrierService, DialogService, DroitsService, StateService } from '../../../../../services'
import { CourrierDialog } from '../courrier-dialog/courrier-dialog.component'
import { EventEmitter,Output} from '@angular/core'

const KEY = 'choice-courrier-dialog'

@Component({
  selector: 'atyl-choice-courrier',
  templateUrl: './choice-courrier.component.html',
  styleUrls: ['./choice-courrier.component.scss']
})
@Stringable({
  path: "views/partials/layout/dialogs/choice-courrier-dialog",
  key: KEY,
})
export class ChoiceCourrierComponent extends BaseDialogComponent implements OnInit {

    @StringableValues(KEY) strings: any
    droits: any = [];
    courriers: any[]
    instruction: any;
    typeCourrier: any[]
    selectedCourrier: any
    destinataire: any = {};
    libres: any = [];
    isLoadDossier: boolean
    isLoadAgrement: boolean
    isLoadFormation: boolean
    isLoadInstruction: boolean
    selectedType: any
    currentDossier: any
    demandeType: string
    typeCourriers: any
	typeCourriersFilters:any;
	
    intervention:any
    
    panierLines:any=[];
        
    droitsObjets: any;
   
	typeDemandeID:string="DOSSIER";
	consultation:any;
	visites:any[]=[];
	
	search: any;
	
  @Output() onFormClosed = new EventEmitter<any>();  

  constructor(
    public dialogRef: MatDialogRef<ChoiceCourrierComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    public droitsService: DroitsService,
    dialogService: DialogService,
    private stateService: StateService,
    private courrierService: CourrierService
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    if (this.data && this.data.dossier) {
      this.currentDossier = this.data.dossier
    }

    if (this.data && this.data.panierLines) {
        this.panierLines = this.data.panierLines
        if (this.panierLines.length>0)
         this.currentDossier = this.panierLines[0].dossier;
      }
    
  if (this.data && this.data.consultation) {
         this.consultation = this.data.consultation
        
   }  
     
	if (this.data && this.data.typeDemandeID) {
	        this.typeDemandeID = this.data.typeDemandeID
	       
	  }  
	
	
    if (this.data != undefined && this.data.intervention != undefined  && this.data.intervention) {
            this.intervention = this.data.intervention
    }
    
    if (this.data != undefined && this.data.instruction != undefined  && this.data.instruction) {
            this.instruction = this.data.instruction
    }
    if (this.data.droits!=undefined)
    	this.droits = this.data.droits
    this.stateService.dossier.pipe(first()).subscribe((dossier) => {
      if (this.data.courrier && this.data.courrier.destination)
        this.destinataire = this.data.courrier.destination.ID
      else
        this.destinataire = dossier.ID
    })

    if(this.data.droitsObjets != undefined)
        this.droitsObjets = this.data.droitsObjets
    // this.courrierService.getCourriersType('DOSSIER').subscribe((result) => {
    //     this.typeCourrier = [];
    //     result.result.forEach((cour) => {
    //         this.typeCourrier.push(cour);
    //     });
    // });

    this.loadTypes()

  }
  loadTypes() {
    
   // let demande_type="DOSSIER";
        
    if (this.instruction!=undefined && this.instruction) {
        console.log("document instruction",this.instruction);
        this.typeDemandeID=this.instruction.demande.type.ID;
      }  
    
    
    this.courrierService.getCourriersType(this.typeDemandeID).subscribe((res: JSONRpcResponse) => {
      this.typeCourriers = []
	  this.typeCourriersFilters = []
      this.typeCourriers = res.result
     
      for(let i=0;i<this.typeCourriers.length;i++) {
		 let c:any=this.typeCourriers[i];
		  c.readAndAdd=true;
		  if (c.courrier !=undefined
		  && c.courrier.key !=undefined && c.courrier.key
		  && this.droits[c.courrier.key]!=undefined
		  && this.droits[c.courrier.key].c!=undefined	
		  )
		  c.readAndAdd=this.droits[c.courrier.key].c;
          if(this.droitsObjets != undefined)
            c = this.setObjectUserRights(c,"courrier");
		  
	  } 
	  this.typeCourriersFilters=[...this.typeCourriers];
	  console.log("ChoiceCourrierComponent",this.droits,this.typeCourriers)
      
    })
  }

  setSelectedCourrier(courrier: any) {
    this.selectedType = courrier
  }

  save() {
    if (this.selectedType) {
      this.dialogRef.close(null)
      this.dialogService.open(CourrierDialog, {
        data: {
          courrier: this.selectedType,
          dossier: this.currentDossier,
          intervention: this.intervention,
          instruction: this.instruction,
          panierLines: this.panierLines,
		  demande_type:  this.typeDemandeID,
		  consultation: this.consultation
        },
        width: "80vw",
        resizable: true,
        minimizable: true,
        draggable: true,
        maximizable: true,
      }, (result: any) => {
            console.log('CourrierDialog close',result);
            this.onFormClosed.emit(result);
      })
    }
  }

setObjectUserRights(obj: any | any[], type: string) {
    if (Array.isArray(obj)) {
        obj.forEach((item: any) => {
            item = this.applyRightsObj(item, type);
        });
    } else {
        obj = this.applyRightsObj(obj, type);
    }
    return obj;
}

applyRightsObj(obj: any, type: string) {
    let rg: any = {
        r: true,
        w: true,
        x: true
    };
    let key = null;
    
    switch (type) {
        case "courrier":
			if (obj.courrier!=undefined )
            	key = obj.courrier.key;
            break;
    }
    if (this.droitsObjets != undefined && this.droitsObjets[type] != undefined) {
        if (this.droitsObjets[type][key] != undefined) {
            rg = this.droitsObjets[type][key];
        }
    }
    obj.droitsObjets = rg;
    return obj;
}

	filterResults() {
	    if (!this.search) {
	      this.typeCourriersFilters = [...this.typeCourriers];
	    } else {
	      this.typeCourriersFilters = [];
	      this.typeCourriersFilters = this.typeCourriers.filter((courrier) => {
	        return courrier.courrier.libelle.toUpperCase().indexOf(this.search.toUpperCase()) > -1;
	      });
	    }

  	}
}
